module.exports = __webpack_public_path__ + "img/05_v1.96782ce8.jpg";